<script>
    import { Bar } from 'vue-chartjs'
    import createChart from './mixins/createChart'

    export default {
        extends: Bar,

        mixins: [createChart],

        props: {
            chartData: {
                type: Object,
                required: true,
                default: () => {}
            },

            options: {
                type: Object,
                default: () => {
                    return {
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    fontColor: '#fff',
                                    fontFamily: "'proxima-nova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    color: '#40424F',
                                    drawTicks: false,
                                    drawBorder: 0
                                },
                                ticks: {
                                    beginAtZero: false,
                                    fontColor: '#fff',
                                    fontFamily: "'proxima-nova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                    padding: 8
                                }
                            }]
                        }
                    }
                }
            },

            scheme: {
                type: String,
                default: 'dark'
            },
        },

        data() {
            return {
                dataStyling: {
                    backgroundColor: [
                        '#FF5D67',
                        '#FF806C',
                        '#FF9771',
                        '#FFAE74',
                        '#FFC678',
                        '#FFDC7C',
                        '#ECE585',
                        '#C6DE92',
                        '#9FD79E',
                        '#78CFAB',
                        '#52C8B8',
                        '#19BDCB',
                    ],
                    borderWidth: 0
                },

                targetDataStyling: {
                    borderColor: '#5E6075',
                    borderDash: [4, 4],
                    borderWidth: 1,
                    pointBackgroundColor: '#FFDC7C',
                    pointBorderColor: '#FFDC7C',
                    pointBorderWidth: 0
                },

                targetChartType: 'line'
            }
        },

        methods: {
            dailyBarColours() {
                if (this.chartData.datasets[0].data.length >= 28 && this.chartData.datasets[0].data.length <= 31) {
                    this.dataStyling = {
                        backgroundColor: [
                            '#19BDCB', // week 1
                            '#52C8B8',
                            '#78CFAB',
                            '#9FD79E',
                            '#C6DE92',
                            '#ECE585',
                            '#FFDC7C',
                            '#19BDCB', // week 2
                            '#52C8B8',
                            '#78CFAB',
                            '#9FD79E',
                            '#C6DE92',
                            '#ECE585',
                            '#FFDC7C',
                            '#19BDCB', // week 3
                            '#52C8B8',
                            '#78CFAB',
                            '#9FD79E',
                            '#C6DE92',
                            '#ECE585',
                            '#FFDC7C',
                            '#19BDCB', // week 4
                            '#52C8B8',
                            '#78CFAB',
                            '#9FD79E',
                            '#C6DE92',
                            '#ECE585',
                            '#FFDC7C',
                            '#19BDCB', // week 5
                            '#52C8B8',
                            '#78CFAB',
                        ],
                    }
                }
            }
        },

        mounted () {
            this.options.scales.xAxes[0].ticks.fontColor = this.isDarkScheme ? '#fff' : '#000'
            this.options.scales.yAxes[0].ticks.fontColor = this.isDarkScheme ? '#fff' : '#000'
            this.dailyBarColours()
            this.createChart()
        },
    }
</script>